
import { mapGetters } from "vuex";
import { mdiChevronRight, mdiInformationOutline } from "@mdi/js";
import reviewCommentModal from "~/components/v2/modals/profiles/review-comment-modal.vue";
import IconNoteEye from "~/components/v2/icons/IconNoteEye.vue";
import IconQuastion from "~/components/v2/icons/IconQuastion.vue";

export default {
  components: {
    reviewCommentModal,
    IconNoteEye,
    IconQuastion,
  },

  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      mdiChevronRight,
      mdiInformationOutline,

      slug: this.$route.params.slug,

      feedbackType: "",

      loading: false,

      dateFormatOptions: {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      },

      // openReviews: [],
    };
  },

  async fetch() {
    await this.$store.dispatch("comments/getProfileReviews", this.profile.id);
  },

  computed: {
    ...mapGetters({
      reviews: "comments/getProfileReviews",
      currentMenu: "comments/getCurrentMenu",
    }),

    isLoggedIn() {
      return this.$auth.loggedIn;
    },

    totalComments() {
      return this.profile.commentsCount;
    },

    unreadComments() {
      return this.profile.commentsCount - this.profile.commentsViewed;
    },

    totalReviews() {
      return this.profile.reviewsCount;
    },

    unreadReviews() {
      return this.profile.reviewsCount - this.profile.reviewsViewed;
    },

    readFullText() {
      return this.currentMenu === "reviews"
        ? this.$t("read-full-review")
        : this.$t("read-more");
    },

    noContentText() {
      return this.currentMenu === "reviews"
        ? this.$t("no-any-reviews-yet")
        : this.$t("no-any-questions-yet");
    },
  },

  mounted() {
    const intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      this.markAsViewed();
    });
    const commentsWrapper = document.querySelector(".comments-wrapper");
    if (commentsWrapper)
      intersectionObserver.observe(document.querySelector(".comments-wrapper"));

    this.$root.$on("open-ask-me-modal", () => {
      this.showForm("comments");
    });
  },

  methods: {
    async changeCurrentMenu({ target }) {
      this.loading = true;

      this.$store.commit("comments/setCurrentMenu", target.value);
      await this.$store.dispatch("comments/getProfileReviews", this.profile.id);
      this.markAsViewed();
      this.$root.$emit("hide-success-form");

      this.loading = false;
    },

    redirectOnAuth() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },

    showForm(feedbackType) {
      if (!this.isLoggedIn) {
        this.redirectOnAuth();
        return;
      }
      this.feedbackType = feedbackType;
      this.$refs.reviewCommentModal.open();
    },

    markAsViewedByEntity(entity) {
      try {
        this.$axios.post(`/api/models/${this.slug}/${entity}/viewed`);
      } catch (error) {
        console.log(error);
      }
    },

    markAsViewed() {
      if (this.currentMenu === "comments" && this.unreadComments > 0) {
        this.markAsViewedByEntity("comments");
      } else if (this.currentMenu === "reviews" && this.unreadReviews > 0) {
        this.markAsViewedByEntity("reviews");
      }
    },
  },
};
